import React from "react";

//Router
import {
  Routes,
  Route,
  Outlet
} from "react-router-dom";

//Protected routes
import Chat from "./Chat";
import Tag from "./Tag";
import Tags from "./Tags";
import Account from "./Account";
import Preset from "./Preset";
import Auction from "./Auction";
import Presets from "./Presets";
import Dashboard from "./Dashboard";
import Customers from "./Customers";
import CustomersDir from "./CustomersDir";
import CustomersDirExpired from "./CustomersDirExpired";
import Utilities from "./Utilities";
import NewPreset from "./NewPreset";
import TagsWrapper from "./TagsWrapper";
import NewCustomers from "./NewCustomers";
import PresetsWrapper from "./PresetsWrapper";
import OutdatedCustomers from "./OutdatedCustomers";
import JuridicCustomers from "./JuridicCustomers";
import AccessReports from "./AccessReports";
import Ranking from "./Ranking";
import VacationTool from "./VacationTool";
import VacationList from "./VacationList";
import VacationWrapper from "./VacationWrapper";
import CustomersTemplate from "./CustomersTemplate";
import CustomersDetails from "./CustomersDetails";
import Prospect from "./Prospect";

//Auth
import SignIn from "./SignIn";
import Password from "./Password";
import RedefinePassword from "./RedefinePassword";
import RedefinePasswordBlank from "./RedefinePasswordBlank";

//Errors
import Error404 from "./404";
import { Profile } from "./Profile";
import ContactEmails from "./ContactEmails";

//Dashboard
import Bids from "./Bids";
import Chains from "./Chains";
import FavLotes from "./FavLotes";
import ChainsNew from "./ChainsNew";
import ChainsEdit from "./ChainsEdit";
import BuyInAuction from "./BuyInAuction";
import CustomersDetailsTemplate from "./CustomersDetailsTemplate";
import ChartProspect from "../components/Dashboard/views/ChartProspect";
import OutdatedTable from "../components/Dashboard/views/OutdatedTable";
import MonthApprovals from "../components/Dashboard/views/MonthApprovals";
import NumberOfLogsAdmin from "../components/Dashboard/views/NumberOfLogsAdmin";
import ApexChartDailyCalls from "../components/Dashboard/views/ApexChartDailyCalls";
import ChartActiveCustomers from "../components/Dashboard/views/ChartActiveCustomers";
import ApexChartSentMessages from "../components/Dashboard/views/ApexChartSentMessages";
import NumberOfLogsCurrentAdmin from "../components/Dashboard/views/NumberOfLogsCurrentAdmin";
import ApexChartReceivedMessages from "../components/Dashboard/views/ApexChartReceivedMessages";
import OverdueCustomersDir from "./OverdueCustomersDir";
import LogsByAdmin from "./LogsByAdmin";
import Conditionals from "./Conditionals";

export function MainRoutes() {
  //const [token, setToken] = useLocalStorage("token", "238fe80d-f3b1-4f19-8098-7c2f67ee2c5e");

  return (
    <Routes>
      <Route path="*" element={<Error404 />} />
      <Route path="/" element={<Dashboard />}>
        <Route index element={<LogsByAdmin />} />
        <Route path="sent-messages" element={<ApexChartSentMessages />} />
        <Route path="received-messages" element={<ApexChartReceivedMessages />} />
        <Route path="month-approvals" element={<MonthApprovals />} />
        <Route path="calls" element={<ApexChartDailyCalls />} />
        <Route path="number-of-logs-from-the-current-admin" element={<ChartActiveCustomers />} />
        <Route path="customer-logins-from-the-current-admin" element={<NumberOfLogsCurrentAdmin />} />
        <Route path="outdated-table" element={<OutdatedTable />} />
        <Route path="chart-prospect" element={<ChartProspect />} />
      </Route>
      <Route path="chains" element={<div><Outlet /></div>}>
        <Route index element={<Chains />} />
        <Route path=":id" element={<ChainsEdit />} />
        <Route path="new" element={<ChainsNew />} />
      </Route>
      <Route path="chat" element={<Chat />} />
      <Route path="condicionais" element={<Conditionals />} />
      <Route path="chat-master" element={<Chat />} />
      <Route path="auction" element={<Auction />} />
      <Route path="outdated-customers-dir" element={<OverdueCustomersDir />} />
      <Route path="access-reports" element={<AccessReports />} />
      <Route path="favorited-lots" element={<FavLotes />} />
      <Route path="customers" element={<Customers />} />
      <Route path="customers" element={<CustomersTemplate />}>
        <Route index element={<Customers />} />
        <Route path=":id" element={<CustomersDetailsTemplate />}>
          <Route index element={<CustomersDetails />} />
          <Route path="bids" element={<Bids />} />
          <Route path="buy-in-auction" element={<BuyInAuction />} />
        </Route>
      </Route>
      <Route path="management-customers" element={<div><Outlet /></div>}>
        <Route index element={<CustomersDir />} />
        <Route path="expired" element={<CustomersDirExpired />} />
        <Route path="prospect" element={<Prospect />} />
      </Route>
      <Route path="new-customers" element={<NewCustomers />} />
      <Route path="outdated-customers" element={<OutdatedCustomers />} />
      <Route path="juridic-customers" element={<JuridicCustomers />} />
      <Route path="ranking" element={<Ranking />} />
      <Route path="contact-emails" element={<ContactEmails />} />
      <Route path="vacation-tool" element={<VacationWrapper />}>
        <Route index element={<VacationList />} />
        <Route path=":id" element={<VacationTool />} />
      </Route>
      <Route path="utils" element={<Utilities />}>
        <Route path="tags" element={<TagsWrapper />}>
          <Route index element={<Tags />} />
          <Route path=":id" element={<Tag />} />
        </Route>
        <Route path="presets" element={<PresetsWrapper />}>
          <Route index element={<Presets />} />
          <Route path=":command" element={<Preset />} />
          <Route path="new" element={<NewPreset />} />
        </Route>
      </Route>
      <Route path="account" element={<Account />} >
        <Route index element={<Profile />} />
        <Route path="tags" element={<Tags />} />
      </Route>
    </Routes>
  );
}

export function AuthRoutes() {

  return (
    <Routes>
      <Route path="/" element={<SignIn />} />
      <Route path="*" element={<Error404 />} />
      <Route path="reset-password" element={<Password />} />
      <Route path="redefine-password" element={<RedefinePasswordBlank />}>
        <Route index element={<RedefinePassword />} />
      </Route>
    </Routes>
  );
}
